{
    "smartTasks": {
        "tourLabel": "Intelligente Aufgaben",
        "learn": "Erfahren Sie, wie Sie mit Cephable Text generieren, umschreiben und übersetzen.",
        "generate": {
            "openTool": {
                "title": "Tool „Text generieren“ öffnen",
                "description": "Klicken Sie im Cephable-Bedienfeld auf das Symbol neben „Intelligente Aufgaben“ und wählen Sie „Text generieren“ aus."
            },
            "enterPrompt": {
                "title": "Eingabeaufforderung eingeben",
                "description": "Geben Sie in das Eingabefeld ein: „Erstellen Sie ein einprägsames Wortspiel in einem Satz.“"
            },
            "clickGenerate": {
                "title": "Klicken Sie auf Generieren",
                "description": "Klicken Sie auf die Schaltfläche „Generieren“. Der Text wird in Echtzeit angezeigt."
            },
            "focusApp": {
                "title": "Konzentrieren Sie sich auf die App",
                "description": "Konzentrieren Sie sich auf die App, in der der generierte Text erscheinen soll. Klicken Sie auf „Generieren“, um Text nahtlos an dieser Stelle zu generieren."
            }
        },
        "rewrite": {
            "welcome": {
                "title": "Willkommen bei Rewrite",
                "description": "Formulieren Sie Inhalte schnell mit hervorgehobenem oder eingefügtem Text um."
            },
            "highlightToggle": {
                "title": "Hervorgehobenen Text verwenden",
                "description": "Stellen Sie sicher, dass „Hervorgehobenen Text verwenden“ ausgewählt ist (Standard)."
            },
            "highlightText": {
                "title": "Markieren Sie den Text zum Umschreiben",
                "description": "Highlight: Ein Oktopus kann jeden Arm unabhängig steuern."
            },
            "enterInstructions": {
                "title": "Geben Sie die Umschreibanweisungen ein",
                "description": "Typ: Im alten englischen Stil."
            },
            "clickGenerate": {
                "title": "Klicken Sie auf Generieren",
                "description": "Ihr markierter Text wird basierend auf Ihrer Eingabe neu geschrieben."
            },
            "pasteMode": {
                "title": "Verwenden Sie „Text einfügen“",
                "description": "Original einfügen und Anweisung neu schreiben. Klicken Sie auf „Generieren“. Klicken Sie zum Zurücksetzen auf „Löschen“."
            },
            "openTool": {
                "title": "Öffnen Sie das Tool „Text umschreiben“",
                "description": "Klicken Sie im Cephable-Bedienfeld auf das Symbol neben „Intelligente Aufgaben“ und wählen Sie „Text umschreiben“ aus."
            },
            "focusApp": {
                "title": "Konzentrieren Sie sich auf die App",
                "description": "Konzentrieren Sie sich auf die App, in der der umgeschriebene Text erscheinen soll. Klicken Sie auf „Generieren“, um Text nahtlos an dieser Stelle zu generieren."
            }
        },
        "translate": {
            "welcome": {
                "title": "Willkommen bei Translate",
                "description": "Übersetzen Sie markierten oder eingefügten Text in eine andere Sprache."
            },
            "highlightToggle": {
                "title": "Hervorgehobenen Text verwenden",
                "description": "Stellen Sie sicher, dass „Hervorgehobenen Text verwenden“ ausgewählt ist."
            },
            "highlightText": {
                "title": "Markieren Sie den zu übersetzenden Text",
                "description": "Highlight: Ein Oktopus kann jeden Arm unabhängig steuern."
            },
            "enterLanguage": {
                "title": "Zielsprache eingeben",
                "description": "Typ: Portugiesisch."
            },
            "clickGenerate": {
                "title": "Klicken Sie auf Generieren",
                "description": "Die Übersetzung wird an der Stelle in Ihre App eingegeben, an der Sie den Cursor bewegen."
            },
            "pasteMode": {
                "title": "Verwenden Sie „Text einfügen“",
                "description": "Fügen Sie Text und Sprache ein. Klicken Sie auf „Generieren“. Klicken Sie zum Zurücksetzen auf „Löschen“."
            },
            "openTool": {
                "title": "Öffnen Sie das Tool zum Übersetzen von Text",
                "description": "Klicken Sie im Cephable-Bedienfeld auf das Symbol neben „Intelligente Aufgaben“ und wählen Sie „Text übersetzen“ aus."
            }
        },
        "rowDescription": "Intelligente Aufgaben sind die verschiedenen Aufgaben, die die KI von Cephable für Sie erledigen kann. Diese Aufgaben werden durch die KI auf dem Gerät unterstützt und können zum Erstellen von Texten, Zusammenfassen, Umschreiben, Übersetzen und vielem mehr verwendet werden."
    },
    "overview": {
        "title": "Überblick",
        "description": "Cephable ist Ihre persönliche KI – entwickelt für schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivität, die mit Ihnen mitgeht."
    },
    "customControls": {
        "tourLabel": "Immer verfügbare globale und Gerätesteuerungen",
        "rowDescription": "Globale und Gerätesteuerungen sind immer verfügbar, wenn Ihr Mikrofon eingeschaltet ist, unabhängig von der verwendeten App. Sie können diese Steuerungen verwenden, um mit Ihrem Gerät zu interagieren, ohne neue App-Steuerungen erstellen zu müssen. Sie enthalten hilfreiche Befehle wie das Wechseln von Steuerungen oder Apps, das Generieren von Text, das Pausieren Ihres Mikrofons und mehr."
    },
    "profile": {
        "tourLabel": "App-Steuerung",
        "learn": "Erfahren Sie, wie Sie Ihre App-Steuerelemente und Einstellungen in Cephable einrichten.",
        "rowDescription": "App-Steuerelemente sind konfigurierte Steuerelemente, mit denen Sie bestimmte Aktionen ausführen können. Möchten Sie „Nächste Folie“ sagen, um zur nächsten Folie Ihrer Präsentation zu gelangen? Oder den Cursor per Kopfbewegung und Sprachsteuerung für Bearbeitungsverknüpfungen nutzen? Mit App-Steuerelementen ist das möglich. In der Steuerelementzeile werden alle für Ihre aktuelle App verfügbaren Steuerelemente angezeigt.",
        "check": {
            "title": "Überprüfen Sie Ihre verfügbaren Steuerelemente.",
            "description": "App-Steuerungen sind für jede von Ihnen verwendete App verfügbar. Hier sehen Sie die verfügbaren Steuerungen für die aktuell verwendete App. Probieren Sie einen anderen Befehl aus, um zu sehen, wie er funktioniert. Achten Sie jedoch darauf, dass Sie sich auf die App konzentrieren, die Sie steuern möchten."
        }
    },
    "dictation": {
        "tourLabel": "Diktat",
        "learn": "Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freihändig in Text umwandeln.",
        "welcome": {
            "title": "Diktat",
            "description": "Mit der Diktierfunktion können Sie natürlich sprechen und Ihre Worte direkt während des Sprechens abtippen lassen. Es ist, als hätten Sie einen persönlichen Assistenten, der alles tippt, was Sie sagen."
        },
        "microphone": {
            "title": "Schalten Sie Ihr Mikrofon ein",
            "description": "Schalten Sie zunächst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."
        },
        "activate": {
            "title": "Diktiermodus starten",
            "description": "Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie „Diktat starten“ oder klicken Sie auf die Schaltfläche „Diktieren“. Schalten wir jetzt den Diktiermodus ein."
        },
        "focus": {
            "title": "Konzentrieren Sie sich auf ein Textfeld oder Dokument",
            "description": "Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Textfeld oder Dokument, in das Sie diktieren möchten."
        },
        "speaking": {
            "title": "Fangen Sie an zu sprechen",
            "description": "Jetzt können Sie lossprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise: „Hallo, dies ist ein Test des Diktiermodus.“"
        },
        "pauseResume": {
            "title": "Diktat pausieren",
            "description": "Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach „Diktat pausieren“. Sie können jederzeit mit „Diktat starten“ fortfahren. Sie können die Funktion mit Ihren globalen Always-On- und Gerätesteuerungen weiter anpassen."
        },
        "stop": {
            "title": "Diktat stoppen",
            "description": "Möchten Sie zurück zur App-Steuerung wechseln? Sagen Sie einfach „Diktat beenden“. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zurück. Sie können jederzeit mit „Diktat starten“ fortfahren."
        },
        "complete": {
            "description": "Das war's! Sie können jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool für freihändiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen müssen."
        }
    },
    "camera": {
        "tourLabel": "Kamerasteuerung",
        "rowDescription": "Mit der Kamerasteuerung können Sie Ihr Gerät mit Gesicht und Körper steuern. Sie können verschiedene Gesichtsausdrücke und Kopfbewegungen verwenden, um Ihr Gerät zu steuern. Bei eingeschaltetem Mikrofon können Sie die Kamera per Sprachbefehl starten, stoppen und zwischen Kameras wechseln.",
        "learn": "Erfahren Sie, wie Sie mithilfe der Kamerasteuerung freihändig auf Ihrem Gerät navigieren und interagieren.",
        "welcome": {
            "title": "Kamerasteuerung",
            "description": "Mit der Kamerasteuerung können Sie Ihr Gerät mit Gesicht und Körper steuern. Nutzen Sie verschiedene Gesichtsausdrücke, Kopfbewegungen und Sprachbefehle, um freihändig auf Ihrem Gerät zu navigieren und zu interagieren."
        },
        "start": {
            "title": "Kamerasteuerung starten",
            "description": "Um die Kamerasteuerung per Sprache zu starten, sagen Sie „Kamerasteuerung starten“ oder klicken Sie auf die Schaltfläche „Kamerasteuerung“."
        }
    },
    "microphone": {
        "tourLabel": "Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie jede App mit Ihrer Stimme steuern und Ihre Worte per Diktierfunktion eintippen können.",
        "description": "Mit der Cephable-Sprachsteuerung können Sie Ihr Gerät per Sprache steuern. Sie möchten ein Dokument speichern? Sagen Sie einfach „Speichern“. Sie möchten Ihre Musik pausieren? Sagen Sie einfach „Pause“. Sie können Ihre Worte auch per Diktierfunktion eintippen.",
        "rowDescription": "Wenn das Mikrofon ausgeschaltet ist, hören wir Ihre Sprachbefehle überhaupt nicht. Wenn Sie es jedoch einschalten, können Sie globale Befehle verwenden, um Pause, Start und mehr umzuschalten. Schalten wir es ein.",
        "start": {
            "title": "Sprachsteuerung starten",
            "description": "Um die Sprachsteuerung zu nutzen, klicken Sie auf den Mikrofonschalter auf dem Cephable-Panel. Dadurch wird das Mikrofon eingeschaltet und empfängt Befehle."
        },
        "tryOpen": {
            "title": "Versuchen Sie, „Öffne Spotify“ oder „Öffne Word“ zu sagen.",
            "description": "„Öffnen“ ist ein globaler Befehl, der die von Ihnen angegebene App öffnet und den Fokus darauf legt. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."
        },
        "finishedCommands": {
            "title": "Ausgezeichnet! Sie haben die Grundlagen der Sprachsteuerung gelernt.",
            "description": "Sie können die Tour jederzeit von der Support-Seite aus erneut aufrufen. Im nächsten Schritt erfahren Sie mehr über die Diktierfunktion. Sie können die Tour von der Support-Seite aus starten."
        }
    },
    "publicProfiles": {
        "tourLabel": "App-Steuerelemente anpassen"
    },
    "tour": {
        "title": "Willkommen bei Cephable",
        "description": "Cephable ist ein leistungsstarkes Tool, mit dem Sie Ihren Computer per Sprache, Kamera und anderen Eingaben steuern können. Diese Tour führt Sie durch die wichtigsten Funktionen und zeigt Ihnen, wie Sie diese effektiv nutzen können.",
        "startTour": "Tour starten",
        "finishTour": "Tour beenden",
        "statusDialog": "Weitere Informationen finden Sie im Panel.",
        "step": "Schritt {{step}} von {{total}}",
        "next": "Nächste",
        "previous": "Vorherige",
        "endTour": "Tour beenden",
        "nextTourLabel": "Weiter: {{nextStepTitle}}",
        "skipTour": "Tour überspringen",
        "steps": {
            "welcome": {
                "title": "Willkommen bei Cephable",
                "description": "Diese Tour führt Sie durch die Hauptfunktionen von Cephable. Los geht's!"
            },
            "inputs": {
                "title": "Übersicht der Eingänge",
                "description": "Cephable unterstützt verschiedene Eingabemethoden, darunter Sprachbefehle, Kamerasteuerung und mehr. Sie können diese Eingaben in den Einstellungen anpassen."
            },
            "appControls": {
                "title": "App-Steuerung",
                "description": "Erstellen Sie App-Steuerelemente, um Ihre Eingaben bestimmten Aktionen in Ihren Anwendungen zuzuordnen. So können Sie Apps mit Gesten, Sprachbefehlen und mehr steuern."
            },
            "settings": {
                "title": "Einstellungen",
                "description": "Greifen Sie auf die Einstellungen zu, um Ihre Eingaben, App-Steuerung und andere Einstellungen zu konfigurieren. Sie können hier auch Ihr Konto und Ihre Spracheinstellungen verwalten."
            },
            "intelligentTasks": {
                "title": "Intelligente Aufgaben",
                "description": "Verwenden Sie intelligente Aufgaben, um mithilfe KI-gestützter Funktionen Text zu generieren, Inhalte zusammenzufassen, Text neu zu schreiben, Sprachen zu übersetzen und mehr."
            },
            "cameraControls": {
                "title": "Kamerasteuerung",
                "description": "Aktivieren Sie die Kamerasteuerung, um Gesichtsausdrücke und Kopfbewegungen als Eingabemethoden zur Steuerung Ihres Computers zu verwenden."
            },
            "voiceControls": {
                "title": "Sprachsteuerung",
                "description": "Steuern Sie Ihren Computer freihändig mit Sprachbefehlen. Diktieren Sie Texte, geben Sie Befehle ein und interagieren Sie mit Anwendungen – ganz einfach per Sprachbefehl."
            }
        }
    },
    "onboarding": {
        "demoPlaceholder": "Dies ist der Platzhalter-Demotext. Mithilfe der obigen Eingabeaufforderungen können Sie die Formatierung dieses Textes steuern.",
        "exit": "Setup beenden",
        "overview": "Überblick",
        "learn": "Informieren Sie sich über die Funktionen von Cephable und deren Verwendung.",
        "start": "Sie scheinen gerade erst anzufangen. Hier sind einige Bereiche, die Ihnen dabei helfen werden.",
        "startTour": "Erste Schritte",
        "dashboard": {
            "title": "Cephable Dashboard",
            "description": "Das Cephable Dashboard ist Ihre zentrale Anlaufstelle für die Verwaltung Ihres Geräts, Ihrer App-Steuerung und Ihrer Einstellungen. Von hier aus können Sie Ihr Erlebnis anpassen, aktive Befehle anzeigen und auf alle Funktionen von Cephable zugreifen."
        },
        "step1": {
            "title": "Willkommen bei Cephable",
            "description": "Cephable ist Ihre persönliche KI – entwickelt für schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivität, die mit Ihnen mitgeht.",
            "inputs": "Was sind Eingaben?",
            "inputDescription": "Eingabesteuerungen sind die Methoden zur Bedienung Ihres Geräts, die die Möglichkeiten Ihres Computers über die herkömmliche Maus und Tastatur hinaus erweitern. Zu diesen Methoden gehören Sprachbefehle, Kopfbewegungen, Mimik und zusätzliche Peripheriegeräte.",
            "profiles": "Was sind App-Steuerelemente?",
            "profileDescription": "App-Steuerungen ermöglichen Ihnen durch die Verknüpfung von Eingabe- und Ausgabesteuerungen eine einzigartige Verbindung und Kommunikation mit Ihrem Computer. Mit App-Steuerungen können Sie Cephable anweisen, Aufgaben wie das Speichern einer Datei durch Neigen des Kopfes oder das Klicken auf „Senden“ einer E-Mail durch ein Lächeln auszuführen.",
            "action": "Eingabesteuerelemente erkunden",
            "secondaryAction": "Weiter zu den App-Steuerelementen",
            "secondaryActionDescription": "Kennen Sie bereits Eingabesteuerelemente?"
        },
        "finish": {
            "title": "Einrichtung abgeschlossen",
            "description": "Sie haben Ihre ersten Cephable-App-Steuerelemente erfolgreich verwendet! Sie können diese und weitere jetzt auf Ihrem Gerät nutzen. Sie finden sie auf Ihrem Cephable-Dashboard, wo Sie die Einstellungen der App-Steuerelemente nach Bedarf anpassen können.",
            "continueToApp": "Weiter zum Cephable Dashboard",
            "keepExploring": "Weiter entdecken"
        },
        "useCaseSlider": {
            "context": "Ich möchte verwenden",
            "control": "kontrollieren"
        }
    },
    "support": {
        "tourLabel": "Bereit, mehr zu erfahren?",
        "description": "Weitere Informationen zur Verwendung von Cephable, einschließlich weiterer Touren, Schritt-für-Schritt-Anleitungen, Tutorials und Videos, finden Sie in unserem Support-Hub.",
        "cta": "Entdecken Sie andere Touren"
    },
    "featureFlag": {
        "title": "Zeit für ein Upgrade",
        "description": "Für die Funktion, die Sie verwenden möchten, ist eine andere Lizenz erforderlich. Führen Sie ein Upgrade durch, um diese und weitere Funktionen freizuschalten."
    },
    "replyToSocialMedia": {
        "tourLabel": "Schnellere Social-Media-Antworten mit Diktierfunktion",
        "learn": "Erfahren Sie, wie Sie per Diktierfunktion freihändig auf Social-Media-Beiträge antworten.",
        "navigateTo": {
            "title": "Navigieren Sie zu einem Social Media-Beitrag",
            "description": "Öffnen Sie Ihren Webbrowser und navigieren Sie zu einer Social-Media-Plattform wie LinkedIn oder Facebook. Suchen Sie einen Beitrag, auf den Sie antworten möchten."
        },
        "speaking": {
            "title": "Beginnen Sie zu sprechen",
            "description": "Jetzt können Sie loslegen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise „Herzlichen Glückwunsch! Ich freue mich für Sie.“ Stellen Sie sicher, dass der Cursor auf einem Textfeld oder Kommentarfeld steht."
        },
        "complete": {
            "description": "Das war's! Sie können jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln, um freihändig auf Social-Media-Beiträge zu antworten. Diktieren ist ein leistungsstarkes Tool für freihändiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen müssen."
        }
    },
    "hotkeys": {
        "tourLabel": "Schnellaktionsschaltflächen",
        "learn": "Erfahren Sie, wie Sie Schnellaktionsschaltflächen einrichten, um einer einzigen Schaltfläche mehrere Aktionen zuzuordnen.",
        "rowDescription": "Mit Schnellaktionsschaltflächen können Sie mehrere Aktionen mit einem einzigen Befehl ausführen. Sie können beispielsweise eine Schaltfläche erstellen, die Ihre Lieblingsmusik-App öffnet und die Wiedergabe einer bestimmten Playlist startet.",
        "check": {
            "title": "Überprüfen Sie Ihre verfügbaren Schnellaktionen.",
            "description": "Für jede App, die Sie verwenden, stehen Schnellaktionstasten zur Verfügung. Hier sehen Sie die verfügbaren Tasten für die aktuell verwendete App. Probieren Sie einen anderen Befehl aus, um zu sehen, wie er funktioniert. Achten Sie jedoch darauf, dass Sie sich auf die App konzentrieren, die Sie steuern möchten."
        }
    },
    "controllingBackgroundMusic": {
        "tourLabel": "Verwalten Sie Hintergrundmusik, ohne Ihren Arbeitsfluss zu unterbrechen",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachsteuerung und Schnellaktionen Ihre Musik freihändig steuern und sich gleichzeitig auf Ihre aktuelle Aufgabe konzentrieren können.",
        "tryOpen": {
            "title": "Versuchen Sie, „Öffne Spotify“ oder „Öffne Apple Music“ zu sagen."
        },
        "play": {
            "title": "Sagen Sie „Play“, um die Musikwiedergabe zu starten.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Play“. Dadurch wird die Musikwiedergabe in der ausgewählten Musik-App gestartet. Dies funktioniert auch mit jeder anderen Medien-App."
        },
        "newPlaylist": {
            "title": "Erstellen einer neuen Playlist",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Neue Playlist“. Dadurch wird der Vorgang zum Erstellen einer neuen Playlist in der von Ihnen gewählten Musik-App gestartet."
        },
        "finishedCommands": {
            "title": "Gut gemacht! Sie haben gelernt, wie Sie Ihre Musik freihändig steuern können.",
            "description": "Sie wissen jetzt, wie Sie in Ihren Lieblingsmusik-Apps mit Sprachbefehlen und Schnellaktionen Titel abspielen, pausieren, überspringen und die Lautstärke anpassen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um Ihre Musik noch einfacher zu steuern."
        }
    },
    "editingVideos": {
        "tourLabel": "Konzentrieren Sie sich auf die Geschichte, nicht auf die mühsamen Klicks zur Videobearbeitung",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachsteuerungen und Schnellaktionen Videos schneller bearbeiten und sich nicht mehr merken müssen, auf welche Schaltflächen Sie während der Bearbeitung klicken müssen.",
        "tryOpen": {
            "title": "Versuchen Sie, „Öffnen Sie iMovie“ oder „Öffnen Sie DaVinci Resolve“ zu sagen."
        },
        "play": {
            "title": "Sagen Sie „Play“, um die Wiedergabe Ihres Videos zu starten.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Play“. Dadurch wird Ihr Video in der von Ihnen gewählten Videobearbeitungs-App abgespielt."
        },
        "stop": {
            "title": "Videowiedergabe stoppen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Stopp“. Dadurch wird die Videowiedergabe in der von Ihnen gewählten Videobearbeitungs-App gestoppt."
        },
        "finishedCommands": {
            "title": "Gut gemacht! Sie haben gelernt, wie Sie Ihre Videobearbeitung freihändig steuern können.",
            "description": "Sie wissen jetzt, wie Sie in Ihren bevorzugten Videobearbeitungs-Apps Sprachbefehle und Schnellaktionen zum Abspielen, Anhalten, Überspringen von Titeln und Anpassen der Lautstärke verwenden. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Videosteuerung noch reibungsloser zu gestalten."
        }
    },
    "vibeCoding": {
        "tourLabel": "Mit Diktierfunktion schneller Ideen entwickeln, Prototypen erstellen und iterieren",
        "learn": "Erfahren Sie, wie Sie Diktat und KI-gestützte Textgenerierung nutzen, um Code zu simulieren, Prototypen zu erstellen und Ideen zu iterieren.",
        "navigateTo": {
            "title": "Navigieren Sie zu einem Vibe-Code-Editor",
            "description": "Öffnen Sie Ihren Webbrowser und navigieren Sie zu einem Vibe-Code-Editor. Einige Beispiele sind Vercel V0, GitHub Copilot in VS Code, Base 44 und Lovable."
        },
        "focus": {
            "title": "Klicken Sie auf „Neuer Chat“ oder „Fokussieren Sie ein Textfeld“",
            "description": "Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Kommentarfeld oder den Antwortthread, in dem Sie diktieren möchten. Beginnen Sie dann zu sprechen."
        },
        "speaking": {
            "title": "Beginnen Sie zu sprechen",
            "description": "Jetzt können Sie loslegen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Geben Sie Ihre technischen Anforderungen und die Funktion des Codes an. Stellen Sie sicher, dass der Cursor auf einem Textfeld oder Kommentarfeld steht."
        },
        "rewriteIntro": {
            "title": "Code mit Anweisungen neu schreiben",
            "description": "Sie können auch intelligente Aufgaben wie „Rewrite“ verwenden, um vorhandenen Code direkt zu ändern. Diese Aufgabe wird durch geräteinterne KI unterstützt, d. h. sie funktioniert ohne Internetverbindung und wird von Ihrem Gerät aus ausgeführt."
        },
        "highlightText": {
            "title": "Markieren Sie den Text zum Umschreiben",
            "description": "Markieren Sie den Code, den Sie neu schreiben möchten."
        },
        "enterInstructions": {
            "title": "Geben Sie die Umschreibanweisungen ein",
            "description": "Geben Sie Ihre Anweisungen zum Umschreiben des Codes ein. Geben Sie die Programmiersprache, den Stil oder alle gewünschten Änderungen an."
        },
        "complete": {
            "description": "Das war's! Sie können jetzt Code diktieren, pausieren, fortsetzen und iterieren. Entdecken Sie weitere Anwendungsfälle mit Diktierfunktion und intelligenten Aufgaben sowie andere Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "documentCode": {
        "tourLabel": "Schnelle, sichere Codedokumentation mit KI-Textgenerierung auf dem Gerät",
        "learn": "Erfahren Sie, wie Sie mithilfe der KI-gestützten Umschreibung Code dokumentieren, während Sie in derselben App bleiben und Ihre Daten sicher halten.",
        "rewriteIntro": {
            "title": "Schreiben Sie Codedokumentation",
            "description": "Sie können Cephable Intelligent Rewrite verwenden, um Codedokumentation in einem separaten Dokument oder einer App zu schreiben. Rewrite ist Teil der On-Device-KI-Aufgaben, einschließlich Offline-Generierung und -Übersetzung."
        },
        "focusApp": {
            "title": "Konzentrieren Sie sich auf Ihren Code",
            "description": "Öffnen Sie Ihre IDE und konzentrieren Sie sich auf den Code, den Sie dokumentieren möchten."
        },
        "newFile": {
            "title": "Erstellen einer Dokumentationsdatei",
            "description": "Erstellen Sie eine neue Datei in Ihrer IDE oder öffnen Sie eine separate App, in der die Dokumentation angezeigt werden soll."
        },
        "highlightText": {
            "title": "Code hervorheben",
            "description": "Markieren und kopieren Sie den Code, den Sie dokumentieren möchten."
        },
        "pasteMode": {
            "title": "Klicken Sie auf die Registerkarte „Text einfügen“",
            "description": "Verwenden Sie den Einfügemodus, um den Originalcode einzufügen und die Dokumentation in eine neue Datei zu schreiben."
        },
        "pasteInput": {
            "title": "Code in Dokument einfügen",
            "description": "Fügen Sie den Code, den Sie dokumentieren möchten, in das Eingabefeld ein."
        },
        "enterInstructions": {
            "title": "Geben Sie Formatierungs-, Stil- und Inhaltsanweisungen ein",
            "description": "Geben Sie die Anweisungen für Ihre Codierungsdokumentation ein. Geben Sie den Dateityp (z. B. Markdown), den Stil oder den gewünschten Inhalt an."
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie Intelligent Tasks für eine schnelle und sichere Codedokumentation nutzen. Entdecken Sie weitere Anwendungsfälle mit Rewrite oder anderen Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "generateCode": {
        "tourLabel": "Schnelle, sichere Codegenerierung mit KI-Textgenerierung auf dem Gerät",
        "learn": "Erfahren Sie, wie Sie mithilfe der KI-gestützten Generierung Codeausschnitte erstellen, während Sie zwischen Apps wechseln und Ihre Daten sicher halten.",
        "rewriteIntro": {
            "title": "Schreiben Sie Code-Snippets",
            "description": "Mit Cephable Intelligent Rewrite können Sie Code-Snippets in Ihrer IDE schreiben, während Sie Anforderungen aus einer anderen Anwendung abrufen. Rewrite ist Teil der On-Device-KI-Aufgaben, einschließlich Offline-Generierung und -Übersetzung."
        },
        "focusApp": {
            "title": "Konzentrieren Sie sich auf den Inhalt Ihres Tickets",
            "description": "Öffnen Sie Ihr Ticket mit den Anforderungen und konzentrieren Sie sich auf den Inhalt, für den Sie Code generieren möchten."
        },
        "newFile": {
            "title": "Erstellen einer Codeausschnittdatei",
            "description": "Erstellen Sie eine neue Datei in Ihrer IDE."
        },
        "highlightText": {
            "title": "Ticketinhalte hervorheben",
            "description": "Markieren und kopieren Sie den Inhalt, für den Sie Code generieren möchten."
        },
        "pasteMode": {
            "title": "Klicken Sie auf die Registerkarte „Text einfügen“",
            "description": "Verwenden Sie den Einfügemodus, um die ursprünglichen Ticketanforderungen einzufügen und Codeausschnitte dafür zu schreiben."
        },
        "pasteInput": {
            "title": "Anforderungen einfügen, um Code zu generieren",
            "description": "Fügen Sie die Anforderungen, die Sie für die Codegenerierung verwenden möchten, in das Eingabefeld ein."
        },
        "enterInstructions": {
            "title": "Geben Sie Anweisungen zur Programmiersprache und zum Stil ein",
            "description": "Geben Sie Ihre Programmiersprache und Stilanweisungen ein. Geben Sie die Programmiersprache (z. B. C#), den Stil oder alle spezifischen Codierungsanweisungen an, die Sie haben."
        },
        "translateIntro": {
            "title": "Code-Snippets übersetzen",
            "description": "Sie können Cephable Intelligent Translate auch verwenden, um Code-Snippets direkt in Ihrer IDE von einer Programmiersprache in eine andere zu konvertieren. Translate ist Teil der On-Device-KI-Aufgaben, einschließlich Offline-Generierung und -Umschreiben."
        },
        "copyGeneratedCode": {
            "title": "Kopieren Sie den generierten Code",
            "description": "Nachdem Sie mit den vorherigen Schritten Code generiert haben, markieren und kopieren Sie den generierten Codeausschnitt."
        },
        "translatePasteMode": {
            "title": "Klicken Sie auf die Registerkarte „Text einfügen“",
            "description": "Verwenden Sie den Einfügemodus, um den Originalcode einzufügen und in eine andere Programmiersprache zu übersetzen."
        },
        "enterProgrammingLanguage": {
            "title": "Geben Sie die Zielprogrammiersprache ein",
            "description": "Geben Sie die Programmiersprache ein, in die Sie den Code übersetzen möchten (z. B. Python)."
        },
        "pasteCode": {
            "title": "Fügen Sie den generierten Code in Ihre IDE ein",
            "description": "Gehen Sie zu Ihrer IDE und fügen Sie den kopierten Codeausschnitt in die neue Datei ein, die Sie zuvor erstellt haben."
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Code generieren und übersetzen können. Entdecken Sie weitere Anwendungsfälle mit „Generieren und Übersetzen“ oder anderen Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "requirementDocsFromMeeting": {
        "tourLabel": "Von Notizen zu Produktanforderungsdokumenten in Minuten",
        "learn": "Erfahren Sie, wie Sie mithilfe von AI Intelligent Tasks strukturierte Produktanforderungsdokumente aus Besprechungsnotizen erstellen und gleichzeitig Ihre Daten schützen.",
        "rewriteIntro": {
            "title": "Erstellen von Produktanforderungsdokumenten",
            "description": "Mit Cephable Intelligent Rewrite können Sie aus Besprechungsnotizen strukturierte Produktanforderungsdokumente erstellen. Rewrite ist Teil der On-Device-KI-Aufgaben, einschließlich Offline-Generierung und -Übersetzung."
        },
        "focusNotes": {
            "title": "Öffnen Sie Ihre Besprechungsnotizen",
            "description": "Öffnen Sie Ihre Besprechungsnotizen, Transkriptionen oder andere besprechungsbezogene Textinhalte."
        },
        "highlight": {
            "title": "Besprechungsnotizen hervorheben",
            "description": "Markieren Sie die Besprechungsnotizen, die Sie zum Erstellen eines Produktanforderungsdokuments verwenden möchten."
        },
        "enterInstructions": {
            "title": "Geben Sie die Dokumentstruktur und Inhaltsanweisungen ein",
            "description": "Geben Sie die Anweisungen für Ihr Produktanforderungsdokument ein. Geben Sie die Struktur, den Stil oder den gewünschten Inhalt an."
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Produktanforderungsdokumente erstellen. Entdecken Sie weitere Anwendungsfälle mit Rewrite oder anderen Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "headMouseMovement": {
        "tourLabel": "Freihändiges Gaming-Setup mit Head Mouse",
        "learn": "Erfahren Sie, wie Sie mithilfe von Kopfbewegungen Ihren Mauszeiger steuern und so präzise navigieren und klicken können.",
        "deviceSettings": {
            "title": "Geräteeinstellungen öffnen",
            "description": "Klicken Sie auf die Schaltfläche „Geräteeinstellungen“, um Kopfbewegungen der Maus zu aktivieren."
        },
        "cameraSettings": {
            "title": "Kameraeinstellungen öffnen",
            "description": "Klicken Sie in den Geräteeinstellungen auf Kameraeinstellungen, um auf die Kamerasteuerung zuzugreifen."
        },
        "headMouseSection": {
            "title": "Kopfbewegung zur Maussteuerung",
            "description": "Wenn diese Option aktiviert ist, werden anstelle der Trigger-Steuerung einige Ihrer Kopfbewegungssteuerungen zum Bewegen Ihrer Maus verwendet."
        },
        "steadyGlide": {
            "title": "Steady Glide-Modus",
            "description": "Aktivieren Sie den Steady-Glide-Modus. Wenn Sie Ihren Kopf über einen bestimmten Punkt hinaus bewegen, gleitet der Cursor kontinuierlich mit konstanter Geschwindigkeit in diese Richtung."
        },
        "customization": {
            "title": "Anpassen der Head Mouse-Einstellungen",
            "description": "Sie können die Einstellungen der Kopfmaus an Ihre Vorlieben anpassen. Passen Sie Geschwindigkeit, Empfindlichkeit und andere Einstellungen an, um das beste Erlebnis zu erzielen."
        },
        "save": {
            "title": "Head-Maus-Einstellungen speichern",
            "description": "Vergessen Sie nicht, Ihre benutzerdefinierten Kopfmauseinstellungen zu speichern."
        },
        "transition": {
            "title": "Wechseln zum Cephable-Panel",
            "description": "Wechseln wir nun zum Cephable Panel, um Kopfbewegungen der Maus auszuprobieren."
        },
        "playGames": {
            "title": "Spiele mit Head Mouse",
            "description": "Jetzt können Sie Ihren Mauszeiger beim Spielen mit Kopfbewegungen steuern. Probieren Sie es aus und sehen Sie, wie es funktioniert!"
        }
    },
    "clinicalNoteTaking": {
        "tourLabel": "HIPAA-konformes Diktieren und Formatieren für Kliniker",
        "learn": "Erfahren Sie, wie Sie Sprachbefehle, intelligente Diktierfunktion und KI-Formatierung zum Erstellen klinischer Notizen verwenden.",
        "speaking": {
            "title": "Beginnen Sie zu sprechen",
            "description": "Jetzt können Sie sprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Versuchen Sie beispielsweise, etwas zu sagen wie: „Der Patient ist ein 45-jähriger Mann mit Bluthochdruck in der Vorgeschichte. Das letzte verschriebene Medikament wirkte nicht wie erwartet und löste eine allergische Reaktion aus. Wir müssen nach alternativen Medikamenten suchen, und er möchte ein Generikum.“"
        },
        "rewriteIntro": {
            "title": "Formatieren Sie Ihre Notizen",
            "description": "Jetzt können Sie Cephable Intelligent Rewrite verwenden, um Ihre Notizen im SOAP-Stil zu formatieren. Dies geschieht alles auf dem Gerät, sodass Ihre Daten privat, sicher und HIPAA-konform bleiben."
        },
        "copyText": {
            "title": "Kopieren Sie die Notizen",
            "description": "Nachdem Sie Ihre Notizen markiert haben, kopieren Sie den Text, um ihn für die Formatierung vorzubereiten."
        },
        "pasteMode": {
            "title": "Klicken Sie auf die Registerkarte „Text einfügen“",
            "description": "Verwenden Sie den Einfügemodus, um die Originalnotizen einzufügen und sie im SOAP-Stil zu formatieren."
        },
        "pasteInput": {
            "title": "Notizen zum Formatieren einfügen",
            "description": "Fügen Sie die Notizen, die Sie formatieren möchten, in das Eingabefeld ein."
        },
        "enterInstructions": {
            "title": "Formatierungsanweisungen eingeben",
            "description": "Sie können Formatierungsanweisungen schreiben, die für Ihre Klinik/Ihr EHR-System befolgt werden müssen. (Beispiel: Formatieren Sie im SOAP-Stil mit Überschriften, Aufzählungspunkten und prägnanter Sprache.)"
        },
        "navigateToEHR": {
            "title": "Navigieren Sie zu Ihrem EHR-System",
            "description": "Öffnen Sie Ihr EHR-System und navigieren Sie zu dem Abschnitt, in dem Sie die formatierten Notizen eingeben möchten."
        },
        "focusTextField": {
            "title": "Konzentrieren Sie sich auf das Textfeld",
            "description": "Klicken Sie auf das Textfeld, in das Sie die formatierten Notizen einfügen möchten."
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie Sprachbefehle und intelligente Diktierfunktion nutzen, um klinische Notizen zu dokumentieren, und wie Sie diese mit Intelligent Rewrite im SOAP-Stil formatieren. Entdecken Sie weitere Anwendungsfälle mit Diktierfunktion und Rewrite sowie weitere Funktionen zur Optimierung Ihres Workflows."
        },
        "focus": {
            "title": "Konzentrieren Sie sich auf ein Dokument",
            "description": "Das Diktieren funktioniert am besten, wenn Sie sich auf ein Dokument konzentrieren. Öffnen Sie ein Dokument, in dem Sie zwischen den Sitzungen klinische Notizen machen möchten."
        }
    },
    "webBrowsing": {
        "tourLabel": "Planen Sie Reisen, kaufen Sie online ein und surfen Sie im Internet per Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachbefehlen navigieren, scrollen und Formulare ausfüllen, während Sie freihändig im Internet surfen.",
        "tryOpen": {
            "title": "Versuchen Sie, „Chrome öffnen“ oder „Edge öffnen“ zu sagen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Chrome öffnen“ oder „Edge öffnen“. Dadurch wird der gewünschte Webbrowser geöffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer App passen."
        },
        "search": {
            "title": "Suche",
            "description": "Sagen Sie beispielsweise „Suchen“ oder „Suchen nach“. Dadurch wird die Suchleiste in Ihrem Browser fokussiert."
        },
        "quickType": {
            "title": "Schnelles Tippen",
            "description": "Mit der Schnelleingabe können Sie per Spracheingabe tippen, ohne den Diktiermodus zu aktivieren. Sagen Sie beispielsweise „Wie ist das Wetter heute?“. Dadurch wird Ihre Suchanfrage in die Suchleiste eingegeben."
        },
        "enter": {
            "title": "Drücken Sie die Eingabetaste",
            "description": "Sagen Sie „Enter“. Dadurch wird die eingegebene Suchanfrage ausgeführt."
        },
        "scrollDown": {
            "title": "Nach unten scrollen",
            "description": "Sagen Sie „Nach unten scrollen“. Dadurch wird die Webseite nach unten gescrollt."
        },
        "scrollUp": {
            "title": "Nach oben scrollen",
            "description": "Sagen Sie „Nach oben scrollen“. Dadurch wird die Webseite nach oben gescrollt."
        },
        "newTab": {
            "title": "Öffnen Sie einen neuen Tab",
            "description": "Sagen Sie „Neuer Tab“. Dadurch wird ein neuer Tab in Ihrem Browser geöffnet."
        },
        "formsCustomization": {
            "title": "Anpassung des Formularausfüllens",
            "description": "Sie können diese App-Steuerung zum einfachen Ausfüllen von Formularen anpassen. Beispielsweise Vorname, Nachname, E-Mail usw. Anschließend können Sie Schnellaktionen oder Sprachbefehle verwenden, um Formulare noch schneller auszufüllen."
        },
        "complete": {
            "title": "Gute Arbeit!",
            "description": "Sie wissen jetzt, wie Sie mit Sprachbefehlen und Schnellaktionen navigieren, suchen, scrollen und Formulare ausfüllen, während Sie im Internet surfen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um noch flüssiger im Internet zu surfen."
        }
    },
    "spreadsheetReviews": {
        "tourLabel": "Schnelleres Arbeiten in Tabellenkalkulationen mit Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen große Tabellen schnell überprüfen und bearbeiten.",
        "tryOpen": {
            "title": "Sagen Sie „Excel öffnen“ oder „Google Tabellen öffnen“.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Excel öffnen“ oder „Google Tabellen öffnen“. Dadurch wird die von Ihnen gewählte Tabellenkalkulations-App geöffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."
        },
        "selectRow": {
            "title": "Wählen Sie eine Zeile aus",
            "description": "Klicken Sie auf eine Zelle. Sagen Sie dann „Zeile auswählen“. Dadurch wird die gesamte Zeile der fokussierten Zelle ausgewählt."
        },
        "delete": {
            "title": "Inhalt einer Zeile löschen",
            "description": "Sagen Sie „Löschen“. Dadurch wird der Inhalt der ausgewählten Zeile gelöscht."
        },
        "note": {
            "title": "Hinzufügen einer Notiz zu einer Zelle",
            "description": "Klicken Sie auf eine Zelle. Sagen Sie dann „Notiz hinzufügen“. Dadurch können Sie der fokussierten Zelle eine Notiz hinzufügen."
        },
        "addNote": {
            "title": "Geben Sie die Notiz ein",
            "description": "Sagen Sie beispielsweise „Geben Sie diese Zahlen ein, die nicht übereinstimmen.“. Dadurch wird Ihre Notiz in die Zelle eingegeben."
        },
        "currentDate": {
            "title": "Aktuelles Datum eingeben",
            "description": "Klicken Sie auf eine Zelle. Sagen Sie dann „Aktuelles Datum“. Dadurch wird das aktuelle Datum in die fokussierte Zelle eingetragen."
        },
        "copy": {
            "title": "Kopieren einer Zelle",
            "description": "Klicken Sie auf die Zelle, der Sie gerade das aktuelle Datum hinzugefügt haben. Sagen Sie dann „Kopieren“. Dadurch wird das aktuelle Datum kopiert."
        },
        "selectColumn": {
            "title": "Wählen Sie eine Spalte aus",
            "description": "Sagen Sie beispielsweise „Spalte“. Dadurch wird die gesamte Spalte für die fokussierte Zelle ausgewählt."
        },
        "paste": {
            "title": "Aktuelles Datum einfügen",
            "description": "Sagen Sie „Einfügen“. Dadurch wird das aktuelle Datum in die ausgewählte Spalte eingefügt."
        },
        "quickActions": {
            "title": "Verwenden Sie Schnellaktionen",
            "description": "Viele dieser und weitere Steuerelemente lassen sich auch mit Schnellaktionsschaltflächen steuern. Sie können diese Schaltflächen an Ihren Arbeitsablauf anpassen und so die Überprüfung und Bearbeitung von Tabellenkalkulationen noch schneller gestalten."
        },
        "complete": {
            "description": "Sie wissen nun, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen große Tabellen schnell überprüfen und bearbeiten können. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Tabellenverwaltung zu beschleunigen."
        }
    },
    "socialMediaWriting": {
        "tourLabel": "Erstellen, iterieren und posten Sie Social-Media-Inhalte mit Sprache und On-Device-KI",
        "learn": "Erfahren Sie, wie Sie mit Intelligent Generate and Rewrite – völlig privat und auf dem Gerät – Inhalte erstellen und iterieren können.",
        "onDeviceIntro": {
            "title": "Ihre Forschung bleibt privat und sicher",
            "description": "Die intelligenten Aufgaben von Cephable basieren auf geräteinterner KI, sodass Ihre Daten vertraulich und sicher bleiben. Sie können Texte ohne Cloud-Verarbeitung erstellen, umschreiben und übersetzen. Nutzen Sie außerdem anwendungsübergreifenden Kontext und entwickeln Sie Ideen direkt in Ihrer bevorzugten App weiter."
        },
        "enterPrompt": {
            "title": "Beginnen Sie mit der Ideenfindung",
            "description": "Geben Sie in das Eingabefeld eine Eingabeaufforderung für den Inhalt ein, den Sie erstellen oder generieren möchten. Sie können beispielsweise Folgendes eingeben: „Listen Sie die Risiken von Agentic AI auf, wo einige Lücken liegen und wie Innovationen vorangetrieben werden können.“"
        },
        "customizeSettings": {
            "title": "Anpassen der Generierungseinstellungen",
            "description": "Sie können die Generierungseinstellungen an Ihre Präferenzen anpassen. Passen Sie die Einstellungen mit Systemaufforderungen an, die Ton, Markenstimme und mehr widerspiegeln."
        },
        "rewriteIntro": {
            "title": "Inhalt iterieren",
            "description": "Mit Cephable Intelligent Rewrite können Sie Inhalte direkt in Ihrer bevorzugten App iterieren. Dies geschieht alles auf dem Gerät, sodass Ihre Daten privat und sicher bleiben."
        },
        "highlightText": {
            "title": "Markieren Sie den Text zum Umschreiben",
            "description": "Markieren Sie eines der aufgelisteten Risiken aus dem generierten Inhalt, das Sie weiter iterieren möchten."
        },
        "enterInstructions": {
            "title": "Geben Sie die Umschreibanweisungen ein",
            "description": "Geben Sie Ihre Umschreibanweisungen ein. Sie können beispielsweise Folgendes eingeben: „Fügen Sie weitere Details zu den Risiken hinzu.“"
        },
        "writeSocialMediaPost": {
            "title": "Schreiben Sie einen Social-Media-Beitrag",
            "description": "Verwenden Sie „Rewrite“ erneut, um diese Sprache in einen öffentlich zugänglichen Social-Media-Beitrag umzuformatieren, der die wichtigsten Punkte enthält und Bereiche des Engagements hervorhebt."
        },
        "highlightPost": {
            "title": "Markieren Sie den generierten Beitrag",
            "description": "Markieren Sie den generierten Social-Media-Beitrag, den Sie verwenden möchten."
        },
        "enterPostInstructions": {
            "title": "Postanweisungen eingeben",
            "description": "Geben Sie Ihre Post-Anweisungen ein. Sie können beispielsweise Folgendes eingeben: „Machen Sie es prägnant und ansprechend für LinkedIn.“"
        },
        "complete": {
            "description": "Jetzt können Sie Ihre bevorzugte Social-Media-Plattform öffnen, auf das Textfeld zur Beitragserstellung klicken und den generierten Beitrag einfügen. Oder Sie können weiter iterieren und verfeinern, bis Sie fertig sind!"
        }
    },
    "inboxTriage": {
        "tourLabel": "Effizientes E-Mail-Management mit Sprache und On-Device-KI",
        "learn": "Erfahren Sie, wie Sie Sprachbefehle und intelligente Aufgaben verwenden, um Ihren Posteingang effizient zu verwalten und gleichzeitig Ihre Daten zu schützen.",
        "tryOpen": {
            "title": "Versuchen Sie, „Outlook öffnen“ oder „Gmail öffnen“ zu sagen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Outlook öffnen“ oder „Gmail öffnen“. Dadurch wird die gewünschte E-Mail-App geöffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."
        },
        "select": {
            "title": "Wählen Sie eine E-Mail",
            "description": "Klicken Sie auf eine E-Mail. Sagen Sie dann „E-Mail auswählen“. Dadurch wird die fokussierte E-Mail ausgewählt."
        },
        "delete": {
            "title": "Löschen einer E-Mail",
            "description": "Sagen Sie „Löschen“. Dadurch wird die ausgewählte E-Mail gelöscht."
        },
        "reply": {
            "title": "Auf eine E-Mail antworten",
            "description": "Klicken Sie auf eine E-Mail. Sagen Sie anschließend „Antworten“. Dadurch wird das Antwortfenster für die fokussierte E-Mail geöffnet."
        },
        "dictateIntro": {
            "title": "Diktieren Sie Ihre Antwort",
            "description": "Sie können Ihre Antwort per Diktierfunktion freihändig eingeben. Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet und der Diktiermodus aktiviert ist."
        },
        "dictateReply": {
            "title": "Beginnen Sie mit der Antwort",
            "description": "Schreiben Sie beispielsweise: „Ich möchte mehr über Ihre Dienstleistungen erfahren. Bitte senden Sie mir weitere Informationen.“ So schreiben Sie Ihre Antwort in die E-Mail. Konzentrieren Sie sich auf das Antwortfeld."
        },
        "newEmail": {
            "title": "Erstellen einer neuen E-Mail",
            "description": "Sagen Sie „Neue E-Mail“. Dadurch wird ein neues Fenster zum Verfassen einer E-Mail geöffnet."
        },
        "customEmailTemplates": {
            "title": "Benutzerdefinierte E-Mail-Vorlagen",
            "description": "Sie können benutzerdefinierte E-Mail-Vorlagen für häufige Antworten erstellen. So können Sie mithilfe von Sprachbefehlen oder Schnellaktionen schnell vorgefertigte Inhalte in Ihre E-Mails einfügen."
        },
        "editAppControls": {
            "title": "App-Steuerelemente bearbeiten",
            "description": "Um eine benutzerdefinierte E-Mail-Vorlage zu erstellen, klicken Sie auf die Schaltfläche „App-Steuerelemente bearbeiten“."
        },
        "addNewControl": {
            "title": "Neues Steuerelement hinzufügen",
            "description": "Klicken Sie im App-Steuerelement-Editor auf die Schaltfläche „Neues Steuerelement hinzufügen“."
        },
        "quickAction": {
            "title": "Schnellaktion auswählen",
            "description": "Wählen Sie als Steuerungstyp „Schnellaktion“."
        },
        "templateName": {
            "title": "Benennen Sie Ihre Vorlage",
            "description": "Geben Sie Ihrer benutzerdefinierten E-Mail-Vorlage einen Namen, beispielsweise „Besprechungsanfrage“."
        },
        "eventType": {
            "title": "Ereignistyp auswählen",
            "description": "Wählen Sie im Abschnitt „Ereignistyp“ den Ereignistyp „Typ“ aus."
        },
        "typeSteps": {
            "title": "Typvorlageninhalt",
            "description": "Geben Sie den Inhalt Ihrer E-Mail-Vorlage ein. Beispiel: „Lead Outreach\nHallo, ich möchte ein Treffen vereinbaren, um mögliche Kooperationsmöglichkeiten zu besprechen. Bitte teilen Sie mir Ihre Verfügbarkeit mit.“"
        },
        "finish": {
            "title": "Erstellen der Vorlage abschließen",
            "description": "Klicken Sie auf die Schaltfläche „Fertig stellen“, um die Erstellung Ihrer benutzerdefinierten E-Mail-Vorlage abzuschließen."
        },
        "saveTemplate": {
            "title": "Speichern Sie Ihre Vorlage",
            "description": "Klicken Sie auf die Schaltfläche „Speichern“, um Ihre benutzerdefinierte E-Mail-Vorlage zu speichern."
        },
        "focusApp": {
            "title": "Konzentrieren Sie sich wieder auf Ihre E-Mail-App",
            "description": "Gehen Sie zurück zu Ihrer E-Mail-App und achten Sie darauf, dass Sie sich auf die Betreffzeile der neuen E-Mail konzentrieren."
        },
        "useTemplate": {
            "title": "Verwenden Sie Ihre Vorlage",
            "description": "Jetzt können Sie Ihre benutzerdefinierte E-Mail-Vorlage verwenden, indem Sie ihren Namen sagen oder auf die Schaltfläche „Schnellaktion“ klicken."
        },
        "generateIntro": {
            "title": "E-Mail-Inhalte generieren",
            "description": "Sie können Cephable Intelligent Generate auch verwenden, um E-Mail-Inhalte direkt in Ihrer E-Mail-App zu erstellen. Dies geschieht alles auf Ihrem Gerät, sodass Ihre Daten privat und sicher bleiben."
        },
        "enterPrompt": {
            "title": "E-Mail-Eingabeaufforderung",
            "description": "Geben Sie in das Eingabefeld Folgendes ein: Schreiben Sie eine professionelle E-Mail an einen potenziellen Kunden, in der Sie unsere Dienste vorstellen und um ein Treffen bitten."
        },
        "focusNewEmail": {
            "title": "Konzentrieren Sie sich auf die neue E-Mail",
            "description": "Stellen Sie sicher, dass Sie sich auf das neue E-Mail-Erstellungsfenster konzentrieren, in dem der generierte Text angezeigt werden soll."
        },
        "translateEmail": {
            "title": "E-Mail-Inhalte übersetzen",
            "description": "Mit Cephable Intelligent Translate können Sie E-Mail-Inhalte direkt in Ihrer E-Mail-App übersetzen. Dies geschieht direkt auf Ihrem Gerät, sodass Ihre Daten vertraulich und sicher bleiben."
        },
        "highlightText": {
            "title": "E-Mail-Inhalte hervorheben",
            "description": "Markieren Sie den Inhalt einer langen E-Mail, die Sie übersetzen möchten."
        },
        "enterLanguage": {
            "title": "Geben Sie die Übersetzungssprache ein",
            "description": "Geben Sie Ihre Übersetzungssprache ein. Sie können beispielsweise „Spanisch“ eingeben."
        },
        "complete": {
            "description": "Sie wissen jetzt, wie Sie mit Sprachbefehlen und intelligenten Aufgaben E-Mails navigieren, beantworten, diktieren, erstellen und übersetzen und gleichzeitig Ihre Daten schützen. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um Ihre E-Mails noch einfacher zu verwalten."
        }
    },
    "handsFreeMeeting": {
        "tourLabel": "Schnelle, freihändige Meeting-Steuerung",
        "learn": "Sparen Sie Zeit und reduzieren Sie die Ermüdung bei virtuellen Meetings mit schnellen, freihändigen Meeting-Steuerelementen",
        "tryOpen": {
            "title": "Versuchen Sie, „Zoom öffnen“ oder „Teams öffnen“ zu sagen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Zoom öffnen“ oder „Teams öffnen“. Dadurch wird die von Ihnen gewählte Meeting-App geöffnet. Wenn Sie die automatische Steuerungsumschaltung aktiviert haben, wird auch zu den App-Steuerelementen gewechselt, die am besten zu Ihrer verwendeten App passen."
        },
        "mute": {
            "title": "Sagen Sie „Stummschalten“, um Ihr Mikrofon stummzuschalten.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Stummschalten“. Dadurch wird Ihr Mikrofon in der ausgewählten Meeting-App stummgeschaltet."
        },
        "video": {
            "title": "Sagen Sie „Video umschalten“, um Ihre Kamera ein- oder auszuschalten",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Video umschalten“. Dadurch wird Ihre Kamera in der ausgewählten Meeting-App ein- oder ausgeschaltet."
        },
        "raiseHand": {
            "title": "Versuchen Sie, „Hand heben“ zu sagen, um Ihre Hand zu heben",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Hand heben“. Dadurch wird Ihre Hand in der von Ihnen gewählten Meeting-App gehoben."
        },
        "quickType": {
            "title": "Schnelles Tippen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Das ist eine coole Funktion“. So können Sie schnell mit Ihrer Stimme tippen, ohne im Diktiermodus zu sein. Stellen Sie sicher, dass Sie in Ihrer Meeting-App auf ein Textfeld fokussiert sind."
        },
        "complete": {
            "description": "Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um in Ihren bevorzugten Meeting-Apps stummzuschalten/die Stummschaltung aufzuheben, das Video ein-/auszuschalten, die Hand zu heben und schnell zu tippen. Probieren Sie weitere Befehle aus oder passen Sie Ihre eigenen Schnellaktionen an, um die Meeting-Steuerung noch reibungsloser zu gestalten."
        }
    },
    "summarizingReports": {
        "tourLabel": "Berichte und Dokumente mit On-Device-KI zusammenfassen",
        "learn": "Erfahren Sie, wie Sie mithilfe der KI-gestützten Zusammenfassung schnell die wichtigsten Punkte aus langen Berichten und Dokumenten herausfiltern und gleichzeitig Ihre vertraulichen und geschützten Daten schützen.",
        "summarizeIntro": {
            "title": "Text zusammenfassen",
            "description": "Mit Cephable Intelligent Tasks können Sie schnell die wichtigsten Punkte aus langen Berichten und Dokumenten erfassen. Summarize ist Teil der On-Device AI Tasks, d. h. es funktioniert ohne Internetverbindung und wird von Ihrem Gerät aus ausgeführt."
        },
        "navigateToReport": {
            "title": "Konzentrieren Sie sich auf Ihren Bericht oder Ihr Dokument",
            "description": "Öffnen Sie Ihren Bericht oder Ihr Dokument in Ihrer bevorzugten App und konzentrieren Sie sich auf den Text, den Sie zusammenfassen möchten."
        },
        "highlightText": {
            "title": "Markieren Sie Text zum Zusammenfassen",
            "description": "Markieren Sie den Text, den Sie zusammenfassen möchten."
        },
        "copyText": {
            "title": "Kopieren Sie den Text",
            "description": "Nachdem Sie Ihren Text markiert haben, kopieren Sie ihn, um ihn für die Zusammenfassung vorzubereiten."
        },
        "enterPrompt": {
            "title": "Zusammenfassungsanweisungen eingeben",
            "description": "Geben Sie Ihre Zusammenfassungsanweisungen ein. Geben Sie die Länge, den Stil oder den gewünschten Inhalt an."
        },
        "pasteText": {
            "title": "Fügen Sie Ihren Berichtsinhalt ein",
            "description": "Fügen Sie nach den Anweisungen den kopierten Text in das Eingabefeld ein."
        },
        "focusChatApp": {
            "title": "Konzentrieren Sie sich auf Ihre Chat-App",
            "description": "Öffnen Sie Ihre Chat-App wie Teams oder Slack und konzentrieren Sie sich auf das Textfeld, in dem der zusammengefasste Text angezeigt werden soll."
        },
        "rewriteIntro": {
            "title": "Zusammengefassten Text neu schreiben",
            "description": "Sie können den zusammengefassten Text auch mit Cephable Intelligent Rewrite weiter verfeinern. Dies geschieht alles auf dem Gerät, sodass Ihre Daten privat und sicher bleiben."
        },
        "highlightSummary": {
            "title": "Markieren Sie den zusammengefassten Text",
            "description": "Markieren Sie den zusammengefassten Text, den Sie weiter verfeinern möchten."
        },
        "enterRewriteInstructions": {
            "title": "Geben Sie die Umschreibanweisungen ein",
            "description": "Geben Sie Ihre Anweisungen zum Umschreiben ein. Geben Sie den Ton, den Stil oder alle gewünschten Änderungen an."
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie mit Intelligent Tasks schnell und sicher Text zusammenfassen und Ergebnisse mit Ihrem Team teilen. Entdecken Sie weitere Anwendungsfälle mit „Zusammenfassen und Umschreiben“ oder anderen Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "congrats": "Glückwunsch!",
    "noteTakingAndDocumentation": {
        "tourLabel": "Notizen machen und Dokumente erstellen mit privater KI auf dem Gerät",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachbefehlen, intelligenter Diktierfunktion und KI-Aufgaben schneller von Notizen zu Entwürfen und Dokumenten gelangen.",
        "focus": {
            "title": "Fokussieren Sie auf ein Textfeld oder Dokument",
            "description": "Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Öffnen Sie ein Dokument oder klicken Sie auf ein Textfeld, in dem Sie Notizen machen möchten."
        },
        "speaking": {
            "title": "Beginnen Sie zu sprechen",
            "description": "Jetzt können Sie loslegen. Sprechen Sie ganz natürlich und lassen Sie Ihren Gedanken freien Lauf, während Sie über Ihre Idee nachdenken. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Beschreiben Sie Ihr Konzept, skizzieren Sie die Schritte oder führen Sie ein freies Brainstorming durch. Sagen Sie zum Beispiel: „Ich denke über einen neuen Workflow für unser Team nach. Zuerst sollten wir den Berichtsprozess automatisieren und dann die Ergebnisse wöchentlich überprüfen.“ Achten Sie darauf, dass der Cursor auf dem Dokument steht."
        },
        "typeEnter": {
            "title": "Absatzumbrüche",
            "description": "Um Absatzumbrüche einzufügen, drücken Sie einfach die Eingabetaste. So können Sie Ihre Notizen in übersichtliche Abschnitte gliedern. Sprechen Sie Ihre Gedanken weiter oder schreiben Sie die Aussagen anderer ab."
        },
        "rewriteIntro": {
            "title": "Designs erstellen",
            "description": "Jetzt können Sie Cephable Intelligent Rewrite verwenden, um Ihre Notizen in eine Funktionsidee oder Folgemaßnahmen umzusetzen. Dies geschieht alles auf dem Gerät, sodass Ihre Daten privat und sicher bleiben."
        },
        "highlightText": {
            "title": "Markieren Sie die Notizen",
            "description": "Wählen Sie alle Notizen aus, die Sie zum Erstellen eines Designs oder Dokuments verwenden möchten."
        },
        "inPlaceReplacement": {
            "title": "Ideenfindung vor Ort",
            "description": "Jetzt verwenden wir die direkte Ersetzung, um Ihre Notizen in ein Design oder Dokument umzuwandeln. Sie können stattdessen jederzeit den Einfügemodus oder die Option zum Erstellen einer neuen Datei verwenden."
        },
        "enterInstructions": {
            "title": "Designanweisungen eingeben",
            "description": "Sie können Ihre nächsten Schritte beschreiben und beschreiben, was Sie mit den Notizen tun möchten. Dies kann Formatierung, Design, Folgeaufgaben oder etwas anderes sein. (Beispiel: Erstellen Sie ein Designdokument, in dem Sie die Funktionsweise der Funktion, den End-to-End-Umgang und mögliche Erfolgsaussichten hervorheben.)"
        },
        "complete": {
            "description": "Sie haben gelernt, wie Sie Sprachbefehle und intelligente Diktierfunktion nutzen, um klinische Notizen zu dokumentieren, und wie Sie diese mit Intelligent Rewrite im SOAP-Stil formatieren. Entdecken Sie weitere Anwendungsfälle mit Diktierfunktion und Rewrite sowie weitere Funktionen zur Optimierung Ihres Workflows."
        }
    },
    "fpsGamePlay": {
        "tourLabel": "Spielen Sie FPS-Spiele mit Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie Sprachsteuerung und Schnellaktionen zum Spielen von FPS-Spielen verwenden.",
        "changeProfile": {
            "title": "Änderungskontrollprofil",
            "description": "Ändern Sie Ihre App-Steuerung auf das FPS-Spielprofil. Sie können dies auch für das jeweilige Spiel anpassen, das Sie spielen möchten. Siehe das Video."
        },
        "autoProfileSwitching": {
            "title": "Automatische Steuerungsumschaltung deaktivieren",
            "description": "Dadurch bleibt Ihre aktuelle App-Steuerung aktiv, bis Sie die App wechseln."
        },
        "tryOpen": {
            "title": "Versuchen Sie, „Öffne Valorant“ oder „Öffne Battlefield“ zu sagen."
        },
        "go": {
            "title": "Versuchen Sie, „Los“ zu sagen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Los“. Dadurch bewegt sich Ihre Figur vorwärts."
        },
        "stop": {
            "title": "Versuchen Sie, „Stopp“ zu sagen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Stopp“. Dadurch wird die Bewegung Ihrer Figur gestoppt."
        },
        "complete": {
            "description": "Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um Ihren Charakter in FPS-Spielen zu bewegen, anzuhalten und zu steuern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um ein noch flüssigeres und schnelleres Gameplay zu erzielen."
        }
    },
    "presentationControls": {
        "tourLabel": "Präsentationen mit Sprachbefehlen steuern",
        "learn": "Erfahren Sie, wie Sie mithilfe von Sprachbefehlen und Schnellaktionen freihändig durch Ihre Präsentationen navigieren und sie steuern können.",
        "tryOpen": {
            "title": "Versuchen Sie, „PowerPoint öffnen“ oder „Google Slides öffnen“ zu sagen."
        },
        "startPresentation": {
            "title": "Sagen Sie „Präsentation starten“, um Ihre Diashow zu starten.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Präsentation starten“. Dadurch wird Ihre Diashow in der von Ihnen gewählten Präsentations-App gestartet."
        },
        "nextSlide": {
            "title": "Sagen Sie „Nächste Folie“, um zur nächsten Folie zu wechseln",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Nächste Folie“. Dadurch wird zur nächsten Folie in Ihrer Diashow gewechselt."
        },
        "previousSlide": {
            "title": "Sagen Sie „Vorherige Folie“, um zur vorherigen Folie zurückzukehren.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Vorherige Folie“. Dadurch gelangen Sie zurück zur vorherigen Folie in Ihrer Diashow."
        },
        "escape": {
            "title": "Versuchen Sie, „Escape“ zu sagen, um den Präsentationsmodus zu verlassen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Escape“. Dadurch wird der Präsentationsmodus in der ausgewählten Präsentations-App beendet."
        },
        "complete": {
            "description": "Sie wissen jetzt, wie Sie mit Sprachbefehlen und Schnellaktionen Präsentationen freihändig starten, navigieren und beenden. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Präsentationssteuerung noch reibungsloser zu gestalten."
        }
    },
    "editingImages": {
        "tourLabel": "Schnellere Bildbearbeitung mit Sprachsteuerung und Diktierfunktion",
        "learn": "Erfahren Sie, wie Sie Sprachbefehle, Schnellaktionen und Diktate verwenden, um Ihren Bildbearbeitungsprozess zu verbessern.",
        "tryOpen": {
            "title": "Versuchen Sie, „Open Figma“ oder „Open Photoshop“ zu sagen."
        },
        "selectAll": {
            "title": "Sagen Sie „Alles auswählen“, um alle Elemente auf der Leinwand auszuwählen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Alles auswählen“. Dadurch werden alle Elemente auf der Leinwand in der gewählten Bildbearbeitungs-App ausgewählt. Konzentrieren Sie sich auf die App."
        },
        "bold": {
            "title": "Sagen Sie „Fett“, um den ausgewählten Text fett darzustellen.",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Fett“. Dadurch wird der ausgewählte Text in der ausgewählten Bildbearbeitungs-App fett dargestellt. Stellen Sie sicher, dass Sie Text ausgewählt haben."
        },
        "copy": {
            "title": "Sagen Sie „Kopieren“, um das ausgewählte Element zu kopieren",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Kopieren“. Dadurch wird das ausgewählte Element in die ausgewählte Bildbearbeitungs-App kopiert. Stellen Sie sicher, dass Sie ein Element ausgewählt haben."
        },
        "paste": {
            "title": "Sagen Sie „Einfügen“, um das kopierte Element einzufügen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Einfügen“. Dadurch wird das kopierte Element in die von Ihnen gewählte Bildbearbeitungs-App eingefügt."
        },
        "delete": {
            "title": "Sagen Sie „Löschen“, um das ausgewählte Element zu löschen",
            "description": "Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet ist, und sagen Sie „Löschen“. Dadurch wird das ausgewählte Element in der gewählten Bildbearbeitungs-App gelöscht. Stellen Sie sicher, dass Sie ein Element ausgewählt haben."
        },
        "dictationIntro": {
            "title": "Diktat",
            "description": "Sie können die Diktierfunktion verwenden, um Text per Spracheingabe einzugeben. Stellen Sie sicher, dass Ihr Mikrofon eingeschaltet und der Diktiermodus aktiviert ist."
        },
        "focus": {
            "title": "Fokus auf ein Textfeld",
            "description": "Klicken Sie in Ihrer Bildbearbeitungs-App auf ein Textfeld, in dem Sie die Diktierfunktion verwenden möchten."
        },
        "speaking": {
            "title": "Beginnen Sie zu sprechen",
            "description": "Sagen Sie beispielsweise: „Scannen Sie den QR-Code, um frühzeitig Rabattcodes zu erhalten. Dieser ist bis zum 30. September gültig. Bewerben Sie sich anschließend über die Website.“ Konzentrieren Sie sich dabei auf das Textfeld oder den Bereich, in dem Sie diktieren möchten."
        },
        "complete": {
            "description": "Sie wissen nun, wie Sie Sprachbefehle, Schnellaktionen und Diktate nutzen können, um Ihre Bildbearbeitung zu verbessern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um die Bildbearbeitung noch reibungsloser zu gestalten."
        }
    },
    "redo": "Onboarding wiederholen",
    "title": "Lernen Sie Cephable kennen",
    "description": "Lernen Sie Cephable kennen, Ihren persönlichen KI-Assistenten, und teilen Sie Ihr Interesse an personalisierten Anwendungsfällen.",
    "panel": {
        "description": "Dies ist das Bedienfeld, die zentrale Steuerungseinheit. Sie ist immer sichtbar und ermöglicht die Steuerung Ihrer Apps per Sprachbefehl und vieles mehr. Beginnen wir mit dem Mikrofon."
    }
}
